/**
 * atomberg-scroll-lock-recovery.js
 *
 * Horizon's dialog.js locks background scroll by setting
 * document.body.style.position = 'fixed' (+ width/top) while any <dialog>
 * (cart drawer, search modal, quick add, mobile menu) is open, and only
 * clears those styles after closeDialog() awaits the closing animation's
 * `animationend` event. If that never fires — e.g. the dialog is still
 * mid-close when the tab is backgrounded, or the animation is interrupted —
 * the lock is left on <body> forever.
 *
 * Setting `position` on <body> makes it the containing block for every
 * `position: fixed` descendant on the page, so once stuck, any fixed/sticky
 * element (the cart's Proceed bar, the PDP sticky ATC bar, etc.) silently
 * stops tracking the viewport and scrolls away with the page instead.
 *
 * This self-heals that state: if no <dialog> is actually open, clear the
 * lock styles dialog.js would have cleared itself. Does not modify dialog.js.
 *
 * It also undoes a jump to the top when the cart drawer closes on mobile.
 * cart-drawer.js pushes a history entry on open — after the lock is on, so
 * the browser saves scrollY 0 for the page — and goes back through it on
 * close (history.back() for X / outside tap, or the phone's Back button).
 * dialog.js restores the real scroll either way, but the browser then
 * re-applies the saved 0 straight after that popstate. Does not modify
 * cart-drawer.js.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergScrollLockRecoveryInit) return;
  w._atombergScrollLockRecoveryInit = true;

  function recover() {
    if (document.body.style.position !== 'fixed') return;
    if (document.querySelector('dialog[open]')) return;
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
  }

  /** @type {number | null} */
  var scrollYAfterNextPopstate = null;

  /** @param {number} scrollY */
  function restoreScrollSoon(scrollY) {
    // The browser applies its saved (stale) scroll right after popstate; this runs after it, before the next paint.
    setTimeout(function () {
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    }, 0);
  }

  /** @param {Element} drawer */
  function bindCartDrawer(drawer) {
    var openedWithHistory = false;

    // dialog:open and dialog:close do not bubble, so they have to be heard on the drawer itself.
    drawer.addEventListener('dialog:open', function () {
      // cart-drawer.js pushes its entry only on mobile breakpoints; its dialog:open listener runs first.
      openedWithHistory = !!(history.state && history.state.cartDrawerOpen);
    });

    drawer.addEventListener('dialog:close', function () {
      if (!openedWithHistory) return;
      openedWithHistory = false;
      // dialog.js has just restored the real scroll; keep it through the history step.
      if (history.state && history.state.cartDrawerOpen) {
        // Closed with X or an outside tap: cart-drawer.js's history.back() is still on its way.
        scrollYAfterNextPopstate = window.scrollY;
      } else {
        // Closed with the Back button: this close is running inside that popstate.
        restoreScrollSoon(window.scrollY);
      }
    });
  }

  window.addEventListener('popstate', function () {
    if (scrollYAfterNextPopstate === null) return;
    restoreScrollSoon(scrollYAfterNextPopstate);
    scrollYAfterNextPopstate = null;
  });

  function init() {
    recover();
    document.querySelectorAll('cart-drawer-component').forEach(bindCartDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catches the case where the tab was backgrounded mid-close (animationend
  // never fires while hidden) and the lock is still stuck once the user
  // returns.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recover();
  });
})();
